{
    "query_builder": {
        "back": "Reports",
        "blocks": {
            "columns": "{count} column | {count} columns",
            "custom": "Your reports",
            "delete": "Delete",
            "delete_confirm": "Delete “{name}”? The report definition goes away; the event’s data is untouched.",
            "new": "New report",
            "new_description": "Build a report from this event’s own fields and measures.",
            "open": "Open"
        },
        "errors": {
            "catalogue": "The report builder could not read this event's fields.",
            "delete": "The report could not be deleted.",
            "export": "The export could not be produced.",
            "missing_report": "That saved report no longer exists.",
            "save": "The report could not be saved.",
            "unknown": "The report could not be run."
        },
        "export_csv": "Export to CSV",
        "export_xlsx": "Export to Excel",
        "exporting": "Preparing…",
        "filter": {
            "apply": "Apply",
            "cancel": "Cancel",
            "edit": "Edit filter",
            "op": {
                "between": "is between",
                "contains": "contains",
                "eq": "is",
                "gt": "is more than",
                "gte": "is at least",
                "in": "is one of",
                "is_empty": "is empty",
                "is_false": "is no",
                "is_not_empty": "is not empty",
                "is_true": "is yes",
                "lt": "is less than",
                "lte": "is at most",
                "neq": "is not",
                "not_in": "is none of",
                "starts_with": "starts with"
            },
            "value": "Value"
        },
        "invite": {
            "action": "Try the report builder",
            "body": "Build your own reports from this event’s own fields — registration answers, sessions, attendees — then save them here beside the built-in reports.",
            "failed": "Could not turn the report builder on. Please try again.",
            "note": "Only for this event. You can turn it off again at any time, and your saved reports are kept.",
            "title": "Report builder",
            "turn_off": "Turn off",
            "turn_off_confirm": "Turn it off",
            "turn_off_text": "It will be removed from this event’s dashboard. Your saved reports are kept, and you can turn it back on whenever you like.",
            "turn_off_title": "Turn off the report builder?",
            "turning_on": "Turning it on…"
        },
        "palette": {
            "empty": "Nothing matches “{term}”.",
            "entity_empty": "Nothing on this event yet — these columns appear once there is something to report on.",
            "fans_out": "fans out",
            "hint": "Click a field to put it on the report. Fields from an entity marked “fans out” make one row per match.",
            "measures": "Measures",
            "search": "Search fields and measures",
            "withheld": "{count} field withheld because it holds personal data | {count} fields withheld because they hold personal data"
        },
        "preview": {
            "empty_body": "Put a field or a measure on it to see rows. The builder tells you what one row means, and warns you when adding a column changes that.",
            "empty_title": "Nothing on the report yet",
            "no_rows": "No rows match this report.",
            "refreshed": "Data refreshed {age} ago",
            "refreshed_now": "Data refreshed just now",
            "rows": "{count} row | {count} rows",
            "run": "Run report",
            "running": "Running…",
            "truncated": "showing the first {limit}"
        },
        "save": "Save",
        "saved": "Saved",
        "saving": "Saving…",
        "shelves": {
            "columns": "Columns",
            "columns_help": "What the report shows, left to right.",
            "drop_here": "Click a field on the left, or drop one here",
            "filters": "Filters",
            "filters_help": "Narrows the rows the report is built from, measures included.",
            "group_action": "Group by this column",
            "group_action_short": "group",
            "group_by": "Group by",
            "group_by_help": "One row per distinct combination of these fields.",
            "group_hint": "Drop a field here, or press GROUP on a column",
            "reorder_hint": "Drag to reorder the columns",
            "ungroup_action": "Stop grouping by this column"
        },
        "sql": {
            "copied": "Copied",
            "copy": "Copy",
            "hide": "Hide SQL",
            "note": "This is what ran against the reporting cache, not a reconstruction of it.",
            "params": "Parameters:",
            "show": "Show SQL",
            "title": "The SQL this report ran"
        },
        "templates": {
            "by_organization": "Attendees by organization",
            "by_organization_desc": "Who is coming, and how much they booked",
            "by_session": "Attendance per session",
            "by_session_desc": "Which sessions filled up",
            "label": "Or start from one of these",
            "roster": "Attendee roster",
            "roster_desc": "One row per attendee, with their details"
        },
        "title": "Report builder",
        "untitled": "Untitled report"
    }
}
